/** Aggregation window length — must match aggregator Stage-2 bucketing. */
export const AGG_WINDOW_MS = 10_000

/**
 * Parse an AcePlayer tick clock value pasted from player/devtools.
 * Accepts unix ms, unix seconds, or an ISO / locale datetime string.
 */
export function parseAcePlayerTimestamp(raw: string): number | null {
  const s = String(raw ?? '').trim()
  if (!s) return null

  if (/^\d{10,16}$/.test(s)) {
    let n = Number(s)
    if (!Number.isFinite(n) || n <= 0) return null
    // 10-digit values are almost always unix seconds.
    if (n < 1e12) n *= 1000
    return n
  }

  const t = Date.parse(s)
  return Number.isFinite(t) ? t : null
}

/** Map a tick `ts` to the aggregator's closed window `[floor(ts/10s)*10s, +10s)`. */
export function aggWindowForTick(tsMs: number): { fromMs: number; toMs: number; windowStartMs: number } {
  const windowStartMs = Math.floor(tsMs / AGG_WINDOW_MS) * AGG_WINDOW_MS
  return { fromMs: windowStartMs, toMs: windowStartMs + AGG_WINDOW_MS, windowStartMs }
}

export function formatWindowBounds(fromMs: number, toMs: number): string {
  const fmt = (ms: number) =>
    new Date(ms).toISOString().replace('T', ' ').replace(/\.\d+Z$/, 'Z')
  return `${fmt(fromMs)} → ${fmt(toMs)}`
}
